import {
  faFlagCheckered,
  faGamepad,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { OverlayTrigger } from 'react-bootstrap';

import ScreenshotOnHover from './ScreenshotOnHover';
import { SkillModel, SkillType } from '../../../common-sk-doc/src/models/skillModel';
import { SkillLevel } from '../../../ui/src/common/enums/enums';
import config from '../../../common-sk-doc/src/config';

const getClassSkill = (skill) => {
  let classCheckpoint =
    skill?.type === SkillType.Checkpoint ? 'checkpoint' : '';
  return `skill-name ${classCheckpoint}`;
};

const CategorySkill: React.FC<{
  skill: SkillModel;
  index: any;
  showIndex?: boolean;
  lessonId?: string;
}> = ({
  skill,
  index,
  showIndex = false,
  lessonId,
}) => {
    const [gameStatus, setGameStatus] = useState<boolean>(false);
    const [placement, setPlacement] = useState<any>('top-start');
    const ref = useRef<any>();
    const lang = 0;

    const [skillLink, setSkillLink] = useState<string>('#');

    // const clickSkill = () => {
    //   return navigate(
    //     `/${skill.type === SkillType.Checkpoint ? 'checkpoints' : 'skills'}/${!skill.pathName ? skill.id : skill.pathName
    //     }${lessonId !== null ? `?lessonId=${lessonId}` : ''}`,
    //   );
    // };
    const clickSkillGame = (e) => {
      window.open(
        skill.linkGame ? `/game/${skill.id}` : `/games/${skill.id}`,
        '_blank',
      );
    };

    const checkPlacement: any = useCallback(() => {
      if (!ref.current) {
        return;
      }
      let height =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight;
      if (ref.current.getClientRects()[0].top < height / 2) {
        setPlacement('bottom-start');
      } else {
        setPlacement('top-start');
      }
    }, [ref]);

    useEffect(() => {
      setGameStatus(skill.showGame);
      setSkillLink(`/${skill.type === SkillType.Checkpoint ? 'checkpoints' : 'skills'}/${!skill.pathName ? skill.id : skill.pathName}${lessonId !== null ? `?lessonId=${lessonId}` : ''}`);
    }, [skill]);
    const classSkill = getClassSkill(skill);
    // if(skill?.type == SkillType.Checkpoint) console.log(skill)
    return skill ? (
      <>
        <div className={classSkill}>
          {classSkill.includes('checkpoint') ? (
            <div className="skill-number">
              <FontAwesomeIcon icon={faFlagCheckered} />
            </div>
          ) : (
            <>
              {showIndex && (
                <div className="skill-number" >
                  {index + 1}.
                </div>
              )}
            </>
          )}
          <div className="d-flex justify-content-between flex-row-reverse w-100 ">
            {(gameStatus ||
              skill.linkGame) && (
                <span className="icon-game px-2" onClick={clickSkillGame}>
                  <FontAwesomeIcon icon={faGamepad} />
                </span>
              )}
            <div className="skill-info d-flex w-100" ref={ref}>
              <OverlayTrigger
                delay={{ show: 250, hide: 0 }}
                placement={placement}
                onEnter={() => checkPlacement()}
                overlay={({ show: _, arrowProps, ...props }) => (
                  <div {...props} id="screenshot-tooltip">
                    <ScreenshotOnHover skill={skill} />
                  </div>
                )}>
                <a
                  href={skillLink}
                >
                  {skill.name}
                </a>
                {/* <span onClick={clickSkill}>
                  <span className="skill-name-info">
                    {skill.type === SkillType.Checkpoint
                      ? ` (${skill.checkpoint.testTime} ${TranslateUnit(
                        'minute',
                        'phút',
                        skill.checkpoint.testTime,
                        lang,
                      ).toLocaleLowerCase()} - ${skill.checkpoint.checkpointHeaders
                        .map((h) =>
                          h.checkpointDetails
                            .map((d) => d.questionCount)
                            .reduce((a, b) => a + b, 0),
                        )
                        .reduce((a, b) => a + b, 0)} ${TranslateUnit(
                          'question',
                          'Câu',
                          skill.checkpoint.checkpointHeaders
                            .map((h) =>
                              h.checkpointDetails
                                .map((d) => d.questionCount)
                                .reduce((a, b) => a + b, 0),
                            )
                            .reduce((a, b) => a + b, 0),
                          lang,
                        ).toLocaleLowerCase()})`
                      : ''}
                  </span>
                </span> */}
              </OverlayTrigger>
              {skill.level === SkillLevel.Difficult && (
                <img
                  className="ms-2"
                  src={
                    config.ASSETS_PATH + '/images/skill/difficult_skill.svg'
                  }
                  alt="difficult"
                  title={'Dạng bài khó' /*Translate('difficult-skill', 'Dạng bài khó')*/}
                />
              )}
            </div>
          </div>
        </div>
      </>
    ) : (
      <></>
    );
  };

export default CategorySkill;
